import { Trans } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { Flex, Text, TextAction } from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';
import { css } from './ComboboxFieldAddSchoolAppendix.css';

export const ComboboxFieldAddSchoolAppendix = () => {
  const router = useRouter();

  return (
    <Flex flexDirection="column" alignItems="center" className={css.root}>
      <Text color="neutral20">
        <Trans
          i18nKey={'dashboard.childcare_voucher.add_new_school.description'}
          components={{
            action: (
              <TextAction
                onClick={() => {
                  router.push(ROUTES.ADD_SCHOOL);
                  AnalyticsService.trackCustomEvent(
                    'new_school_button_clicked'
                  );
                }}
              />
            ),
          }}
        />
      </Text>
    </Flex>
  );
};
